import { Form } from "./Form";

export class JobOfferForm extends Form {
  _fileInput;
  _fileValidationMessage;
  _fileNameMessage;
  _sendButton = null;

  init() {
    this._fileInput = document.getElementById('attachment-input');
    this._fileValidationMessage = document.getElementById('file-validation-message');
    this._fileNameMessage = document.getElementById('file-name-message');
    this._sendButton = document.querySelector("button[type='submit']");
    this.bindEvents();
    super.init();
  }

  prepareFormData() {

    const nameInput = document.getElementById('name-input');
    const surnameInput = document.getElementById('surname-input');
    const position = document.getElementById('subject-input');
    super.prepareFormData();
    this.formData.append(
      'File', this._fileInput.files[0],
      `CV_${ nameInput.value }_${ surnameInput.value }${ (position ? '_' + position.value : '') }.pdf`
    );
  }

  validateFile(file) {
    const fileSize = this._fileInput.files[0].size / 1024 / 1024; // in MiB
    if (fileSize > 2) {
      this._fileInput.value = '';
      this._fileValidationMessage.style.display = 'block';
      this._fileNameMessage.style.display = 'none';
      this._fileNameMessage.innerText = '';
    } else {
      this._fileValidationMessage.style.display = 'none';
      this._fileNameMessage.style.display = 'block';
      this._fileNameMessage.innerText = `${ this._fileInput.files[0].name } (${ Math.ceil(fileSize) } MB)`;
    }
  }

  bindEvents() {
    this._fileInput.addEventListener('change', this.validateFile.bind(this));
  }

  afterFormSendTracking() {
    this._sendButton.disable = false;
    if (window.lintrk) {
      window.lintrk('track', { conversion_id: 8350665 });
    }
  }

  submitForm() {
    this._sendButton.disable = true;
    super.submitForm();
  }
}

